import { JSX } from 'react';
import type { TooltipProps } from '@heroui/react';
import { Tooltip as HeroUITooltip } from '@heroui/react';

import useMergeClassNames from '~/hooks/useMergeClassNames';

export function Tooltip(props: TooltipProps): JSX.Element {
  const { classNames: customClassNames, ...rest } = props;

  const classNames = useMergeClassNames(
    {
      base: ['max-w-64', 'before:bg-tooltip'],
      content: ['bg-tooltip', 'px-2 py-1'],
    },
    customClassNames,
  );

  return <HeroUITooltip classNames={classNames} size="sm" showArrow {...rest} />;
}
